import { computed, makeObservable, observable } from 'mobx';

import Configuracao from '@/util/Configuracao.js';

import { Filtro } from './Filtro';

export default class FiltroDomicilioEletronico extends Filtro {
    tipo = 'booleano';

    constructor(props) {
        super(props);

        makeObservable(this, {
            tipo: observable,
            label: true,
            getValorOpcao: true,
            getDescricao: true,
            renderCarregando: true,
            carregandoDadosComplementares: computed
        });
    }

    get label() {
        return 'Partes com Domicílio Judicial Eletrônico (DJe) - exclusivo para PJe';
    }

    getValorOpcao(registro) {
        if (registro.processo.origem !== Configuracao.ORIGEM_PJE) {
            return false;
        }

        if (!this.store.mapaProcessosPartes) {
            return false;
        }

        const partesProcesso = this.store.mapaProcessosPartes[registro.processo.numeroCompleto];

        if (!partesProcesso?.partes) {
            return false;
        }

        return partesProcesso.partes.some((parte) => parte.codigoDomicilioEletronico);
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoPartes;
    }

    renderCarregando() {
        return this.renderCircularProgress('dados relativos a domicílio judicial eletrônico...');
    }
}
